import { useCombobox } from 'downshift';

// Balance specific
// ------------------------------

export { Combobox } from './Combobox';

export { defaultItemToLabel, defaultItemToValue } from './defaults';
export type {
  ComboboxGetMessageText,
  ComboboxItemsStatus,
  ComboboxLoadingState,
  ComboboxProps,
} from './types';

export { comboboxDynamicTextContainerItemHeight } from './comboboxDynamicTextContainerItemHeight';

// Downshift specific
// ------------------------------

// NOTE: unfortunately downshift implements Enum rather than string literals...
export const stateChangeTypesEnum = useCombobox.stateChangeTypes;

export type {
  UseComboboxState,
  UseComboboxStateChange,
  UseComboboxStateChangeOptions,
  UseComboboxStateChangeTypes,
} from 'downshift';
